import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	defaultIdeaTitle: {
		id: 'polaris-ideas.idea-view.summary.default-idea-title',
		defaultMessage: 'Untitled Idea',
		description: 'Header text to be used as a default when a idea title changes to empty',
	},
});
